import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Features from "../../data/Features/Features";

import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import { handleLoading } from "../../store/actions/loadingAction";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import separateFaceIdType from "../../utils/separateFaceIdType";
import { editCurrentUser, registerUser } from "../../store/actions/usersAction";
import { editMembership } from "../../store/actions/membershipsAction";
import { bioCreateUser } from "../../db/BioStar/APIs";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import useSwr from "swr";
import PriceCalculationModal from "../../components/PackageScreen/PriceCalculationModal";
import { fetcher } from "../../components/UI/TableView/ShowPaginationData";
const smalltalk = require("smalltalk");

function SelectPackageScreen() {
  const [groupOfPackages, setGroupOfPackages] = useState(false);

  const history = useHistory();
  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const { data: packages } = useSwr('/packages?centerId=' + currentCenterId, fetcher)
  const location = useLocation();
  const currentUser = useSelector((state) => state.users.currentUser);
  const currentAdmin = useSelector((state) => state.authentication.user);
  const accessGroups = useSelector((state) => state.accessGroups.accessGroups);
  const advancedPurchase = !!location.search.includes("advancedPurchase");
  const isUpdateCurrentPackage = !!location.search.includes(
    "isUpdateCurrentPackage"
  );
  const { t } = useTranslation();
  const currentDollarPrice = useSelector(state => state.dollarPrices.currentPrice.price);
  const fourNumDollarBuy = (currentDollarPrice - 1000 + '').substring(0, 4);
  const fourNumDollarSell = (currentDollarPrice + 1500 + '').substring(0, 4);

  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })

  const onSelectPackage = async (data) => {
    try {
      let newData = { ...data }
      if (data.paymentDetails.payedType === 0) {
        newData.price = { ...data.price, iqd: Math.round(((data.price.value * Number(fourNumDollarBuy))) / 1000) * 1000, realDollarPrice: currentDollarPrice }
      } else if (data.paymentDetails.payedType === 1) {
        newData.price = { ...data.price, iqd: Math.round(((data.price.value * (Number(fourNumDollarSell)))) / 1000) * 1000, realDollarPrice: currentDollarPrice }
      } else if (data.paymentDetails.payedType === 2) {
        newData.price = { ...data.price, iqd: Math.round(((data.price.value * (Number(fourNumDollarSell)))) / 1000) * 1000, realDollarPrice: currentDollarPrice }
      }

      const membership = {
        adminId: currentAdmin._id,
        centerId: currentCenterId,
        type: currentUser?._id ? 1 : 0,
        package: { ...newData },
      };
      editMembership(membership);

      handleLoading();

      // !this is for face version 1,2 (aka 1,2,3)
      let newAccessGroups = [];
      const faceType = separateFaceIdType(currentCenterId);
      // await Promise.all(data.features.map((ft) => {
      //   if (ft === 0) {
      //     const a = accessGroups.find(
      //       (b) => b.name === "Gym Door"
      //     );

      //     newAccessGroups.push({
      //       id: a.id,
      //       name: a.name,
      //     });
      //   } if (ft === 1) {
      //     // newAccessGroups = [];
      //     const a = accessGroups.find((b) => b.name === "Swim Door");
      //     newAccessGroups.push({
      //       id: a.id,
      //       name: a.name,
      //     });
      //   }
      // }));

      if (newAccessGroups.length === 0) newAccessGroups = currentUser.access_groups
      currentUser.access_groups = newAccessGroups;

      let registerType = 0; //* 0 new user new memberships, 1 update existing user membership or advance purchase, 2 change last membership
      if (advancedPurchase || currentUser._id || isUpdateCurrentPackage) {
        //* currentUser._id This means that the user is outdated and wants to renew membership
        registerType = 1;
      }

      // //* add user and memberships after that get face id
      await registerUser(
        registerType,
        currentUser,
        membership,
        advancedPurchase,
        isUpdateCurrentPackage
      ).then((a) => {
        if (advancedPurchase || currentUser._id || isUpdateCurrentPackage) {
          bioCreateUser({ ...a.user }, true);
        }
        editCurrentUser(a.user)
      })
      handleLoading()

      if (!currentUser._id)
        smalltalk
          .confirm(t("userSuccessfullyAdded"), t("doYouWantToRegisterFace"), {
            ok: t("yes"),
            cancel: t("no"),
          })
          .then(async (value) => {
            history.push(`${window.location.pathname}/getUserCredentials?faceIp=` + accessGroups[0].ip);
          })
          .catch(() => {
            history.replace("/users");
          });
      else
        history.replace("/users");

    } catch (e) {
      console.log({ e });
      handleLoading();
      smalltalk.alert("Error " + e.code, e.message);
    }
  };

  const setUpGroupOfPackages = () => {
    let arr = [];
    let sum = -1;

    let duration = undefined;
    packages.forEach((pck, i) => {
      if (duration !== pck.duration) {
        duration = pck.duration;
        arr.push({ duration, data: [] });
        sum++;
      }
      arr[sum].data.push(pck);
    });

    setGroupOfPackages(arr);
  };

  const onChangeModal = (pck = {}) => {
    if (pck.price && pck.price.discount) {
      let newPackage = { ...pck }
      const newPrice = Math.round(pck.price.value - (pck.price.value * (Number(pck.price.discount) / 100)))
      return setPriceModal(prev => ({ ...prev, show: !prev.show, data: { ...newPackage, price: { ...newPackage.price, value: newPrice } } }))
    }
    setPriceModal(prev => ({ ...prev, show: !prev.show, data: pck.price ? pck : prev.data }))
  }

  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  const onSubmit = () => {
    const pD = { ...priceModal.paymentDetails, payedType: priceModal.payedType, changeType: priceModal.changeType }
    onSelectPackage({ ...priceModal.data, paymentDetails: pD })
    setPriceModal(prev => ({ ...prev, show: false, }))
  }

  useEffect(() => {
    if (packages) setUpGroupOfPackages();
  }, [packages]);

  return (
    <div className="flex flex-col items-center w-full ">
      <HeaderContainer label={""} />
      <PriceCalculationModal from={0} onSubmit={onSubmit} onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />

      <div className="flex flex-col flex-wrap items-center justify-center w-full p-5">
        {groupOfPackages &&
          groupOfPackages.map((gp, i) => {
            return (
              <div key={i} className="w-4/5 mb-20 ">
                <div className="flex items-center justify-center w-full p-2 text-3xl text-white bg-mainAqwaBlue ">
                  {t("numOfDay", { num: gp.duration == 0 ? 1 : gp.duration })}
                </div>
                <div className="flex flex-row flex-wrap justify-center p-5">
                  {gp.data && gp.data.length !== 0 &&
                    gp.data.map((dt) => {
                      return (
                        <PackageCard
                          onSelectPackage={onChangeModal.bind(this, dt)}
                          dt={dt}
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export const PackageCard = ({ onSelectPackage, dt }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const iqdPrice = convertCurrency(dt.price.value, "IQD");
  const packagePrice = dt.price.discount ? dt.price.value - (dt.price.value * (Number(dt.price.discount) / 100)) : dt.price.value
  
  return (
    <div
      onClick={onSelectPackage.bind(this, {
        ...dt,
        price: { ...dt.price, iqd: iqdPrice },
      })}
      className={`flex cursor-pointer flex-col justify-between  m-2 bg-white border h-80 w-60 hover:opacity-80 `}
    >
      <div className="flex flex-col items-center justify-center w-full p-2 h-3/4">
        <h1 className="text-2xl font-medium text-center opacity-80">
          {dt.labelDetails.inEn.title}
        </h1>

        <h1 className="text-2xl opacity-40">
          {convertCurrency(packagePrice, "USD", true, null, true)}
        </h1>
        {/* <h1 className="text-2xl opacity-40">
          {convertCurrency(dt.price.value, "IQD", false, true, true)}
        </h1> */}
        <div className="mt-6">
          {dt.features.map((ft, i) => (
            <h1 key={i}>- {t(Features.find((a) => a.id === ft).label)}</h1>
          ))}
        </div>
      </div>
      <div
        className={`flex items-center justify-end w-full p-5  h-1/5 ${dt?.offerType === 1 ? "bg-purple-400" : "bg-mainAqwaBlue"
          }`}
      >
        <h1 className="text-xl font-bold text-white">
          {t("days")} {dt.duration == 0 ? 1 : dt.duration}
        </h1>
      </div>
    </div>
  );
};

export default SelectPackageScreen;
